<div class="maximize-sidebar-button">
    <ui-map-button [noShadow]="true">
        <ui-icon
            aria-hidden
            [icon]="'sidebar-show'"
        />
    </ui-map-button>
</div>
